/**
 * @fileoverview Chat selection reset and simulated-chat helpers.
 * @module pages/chat/chatSelectionHelpers
 */
import { logger, sanitizeError } from "../../utils/logger.js";
import { buildSimulatedChatContent } from "./chatSimulatedMessage.js";

/** Clears the active chat, read-only state, and loaded messages. */
export const resetChatSelection = (ctx) => {
  ctx.setSelectedChat(null);
  ctx.setSelectedUser(null);
  ctx.setSelectedCompany(null);
  ctx.setChatMessages([]);
  ctx.setIsReadOnlyChat(false);
  ctx.setReadOnlyHeaderTitle(null);
  ctx.setReadOnlyRequestType(null);
  ctx.setReadOnlyRequest(null);
};

/** Opens a read-only preview chat built from a connection request. */
export const openSimulatedChat = (ctx, request) => {
  try {
    const { fullMessage, buyerName, selectedUser } = buildSimulatedChatContent(
      request,
      ctx.users,
      ctx.t,
    );

    ctx.setSelectedUser(selectedUser);
    ctx.setSelectedCompany(request?.senderUserCompany || null);
    ctx.setReadOnlyHeaderTitle(
      `${buyerName} ${ctx.t("pages.chat.buyerLabel")}`,
    );
    ctx.setSelectedChat(null);
    ctx.setChatMessages([
      {
        type: "NEW_MESSAGE",
        chatId: "simulated",
        messageId: Date.now().toString(),
        message: fullMessage,
        senderUserId:
          request?.senderUser?._id || request?.senderUserId || "",
        timestamp: Date.now().toString(),
        messageType: "TEXT",
      },
    ]);
    ctx.setIsReadOnlyChat(true);
    ctx.setReadOnlyRequestType(request?.type || null);
    ctx.setReadOnlyRequest(request || null);

    if (ctx.isCompactViewport) {
      ctx.setShowChatInTablet(true);
    }
  } catch (error) {
    logger.error("Error building simulated chat:", {
      err: sanitizeError(error),
    });
  }
};
